/* @flow */
import {
  REPROCESS_REPORTS,
  SET_REINDEX_OPTIONS,
} from './action-types.js';
import type { DateRange, ReindexOptionsRecord } from './types.js';

export const setReindexOptions = (payload: ReindexOptionsRecord) => ({
  type: SET_REINDEX_OPTIONS,
  payload,
});

export const reprocessReports = (payload: DateRange) => ({
  type: REPROCESS_REPORTS,
  payload,
});



// WEBPACK FOOTER //
// ./src/app/modules/devtasks/actions.js